import axios from "axios";
import { useSelector } from "react-redux";

const useAxios = () => {
    const token = useSelector((state) => state.auth.token);

    const axiosPublic = axios.create({
        baseURL: "https://34112.fullstack.clarusway.com/",
    });

    const axiosWithToken = axios.create({
        baseURL: "https://34112.fullstack.clarusway.com/",
        headers: { Authorization: `Token ${token}` },
    });

    return { axiosPublic, axiosWithToken };
};

export default useAxios;
